export const creds = {
    bucketName: 'ila-app-data-storage',
    bucketRegion: 'us-west-2',
    indentityPoolId: 'us-west-2:a6a994a6-2c21-4705-93eb-92a6496d2c55',
    roleArn: 'arn:aws:iam::223634448983:role/Cognito_simrepsDataUploadPoolUnauth_Role'
}